import { SET_SONG_ATTRIBUTES } from './action-typs';

export function setSongAttributes(payload) {
  const { songTypes, compositions, contractStatus, keyTonics = [], keySignatures = [] } = payload;

  return {
    type: SET_SONG_ATTRIBUTES,
    payload: { songTypes, compositions, contractStatus, keyTonics, keySignatures }
  };
}

